export const getAppToken = (token)=>{
    const promise = new Promise((resolve,reject)=>{
      //判断环境
        let u = navigator.userAgent
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isAndroid) {
            console.log('当前安卓环境');
            window.jxyy.getToken()
            localStorage.setItem("appToken", window.jxyy.getToken());
            resolve();
        } else if (isiOS) {
            window.webkit.messageHandlers.getToken.postMessage("token");
        }
        window.getIosToken = (token) => {
            localStorage.setItem("appToken", token);
            resolve();
        };
    })
    return promise
}
